import { all, call, put, select, takeEvery } from "redux-saga/effects";

import {
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailed,
  CATEGORY_CODE,
  PERSONAL_INFORMATION_CATEGORY,
  INTERNAL_DOCUMENT_CATEGORY,
  CATEGORY_RECRUITMENT_CODE,
} from "../redux/category";

import {
  getCategoryPersonalInformationApi,
  getCategoryInternalDocumentApi,
  getCategoryFactoryApi,
  getCategoryRecruitmentApi,
} from "core/http/service/category";
import { categoryOptionsSelector } from "../redux/selector";
import { formRecruitmentUpdate } from "modules/Recruitment/redux/formInput";

function toQueryString(params: Record<string, any>): string {
  const searchParams = new URLSearchParams();
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      searchParams.append(key, String(params[key]));
    }
  }
  const qs = searchParams.toString();
  return qs ? `?${qs}` : "";
}

export function getKeyWithQuery(
  key: string,
  query: Record<string, any>
): string {
  return `${key}${toQueryString(query)}`;
}

function* getCategoryWork(action: ReturnType<typeof getCategoryStart>) {
  const key =
    typeof action.payload === "string" ? action.payload : action.payload.type;

  const query = typeof action.payload === "string" ? {} : action.payload.query;

  const params =
    typeof action.payload === "string" ? {} : action.payload.params;

  const isUpdateNow =
    typeof action.payload === "string"
      ? false
      : action.payload.isUpdateNow || false;

  const storeKey = getKeyWithQuery(key, { ...query, ...params });
  const categories = yield select(categoryOptionsSelector(storeKey));
  if (categories?.length !== 0 && isUpdateNow === false) {
    if (typeof action.payload !== "string" && action.payload.callback) {
      action.payload.callback(categories);
    }
    return;
  }

  try {
    let res = null;
    if (!!PERSONAL_INFORMATION_CATEGORY[key.split("?")[0]]) {
      // Check cho trường hợp key có thêm query param
      res = yield call(getCategoryPersonalInformationApi, key);
    } else if (!!INTERNAL_DOCUMENT_CATEGORY[key]) {
      res = yield call(getCategoryInternalDocumentApi, key);
    } else if (!!CATEGORY_CODE[storeKey?.split("?")[0]]) {
      res = yield call(getCategoryFactoryApi, key, query, params);
    } else if (!!CATEGORY_RECRUITMENT_CODE[storeKey?.split("?")[0]]) {
      res = yield call(getCategoryRecruitmentApi, key);
    } else return;

    yield put({
      type: getCategorySuccess.type,
      payload: {
        key: storeKey,
        data: res,
      },
    });

    // trường hợp lấy danh sách quản lý tuyển dụng để cập nhật vào form tuyển dụng
    if (key?.includes(CATEGORY_CODE.RECRUITMENT_LIST_MANAGERS)) {
      yield put({
        type: formRecruitmentUpdate.type,
        payload: {
          mngApproveCode: res?.[0]?.value || "",
        },
      });
    }

    if (typeof action.payload !== "string" && action.payload.callback) {
      action.payload.callback(res);
    }
  } catch (error: any) {
    if (typeof action.payload !== "string" && action.payload.callback) {
      action.payload.callback(null);
    }
    yield put({
      type: getCategoryFailed.type,
    });
  }
}

function* watchGetCategory() {
  yield takeEvery(getCategoryStart.type, getCategoryWork);
}

export default function* getLocationSaga() {
  yield all([watchGetCategory()]);
}
